/// For displaying the date in the following format:
/// YYYY-MM-dd-HH:mm
export function displayDate(date_collected) {
    var date = new Date(date_collected);
    var time = date.toUTCString().slice(-12);
    var ret = date.toUTCString();
    if (time === "00:00:00 GMT") {
        ret = ret.slice(0, -12);
    }
    return ret;
}

/**
 * Converts a subscription ID to a readable, text format.
 * @param {Int} subscription
 * @returns The text description of the subscription.
 */
export function convertIdToText(subscription) {
    const FREE_SUBSCRIPTION_ID = 0;
    const MONTHLY_SUBSCRIPTION_ID = 1;

    if (subscription === FREE_SUBSCRIPTION_ID) {
        return "Free";
    } else if (subscription === MONTHLY_SUBSCRIPTION_ID) {
        return "Monthly - $29.99";
    } else {
        return `Unknown subscription ID: ${subscription}`;
    }
}
